<template>
  <v-data-table
    :headers="headers"
    :items="earlyBooking"
    hide-default-footer
    :no-data-text="$t('earlyBookingNoData')"
    class="pb-2"
    dense
  >
    <template v-slot:top>
      <v-card-title tile>
        {{ $t("earlyBookingTitle") }}
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </template>
          <v-card tile>
            <v-card-title>
              <span class="headline">{{ earlyBookingDialogTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                type="number"
                v-model="editedItem.days"
                :label="$t('earlyBookingDays') + ' *'"
                dense
                class="mt-4"
                required
                :error-messages="earlyBookingDaysErrors"
                @input="$v.editedItem.days.$touch()"
                @blur="$v.editedItem.days.$touch()"
              ></v-text-field>
              <v-text-field
                type="number"
                v-model="editedItem.discount"
                :label="$t('earlyBookingDiscount') + ' *'"
                dense
                class="mt-4"
                required
                :error-messages="earlyBookingDiscountErrors"
                @input="$v.editedItem.discount.$touch()"
                @blur="$v.editedItem.discount.$touch()"
              ></v-text-field>
              <small>* {{ $t("validation") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="close">{{
                $t("btnCancel")
              }}</v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="save"
                :disabled="$v.$invalid"
                >{{ $t("btnSave") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card tile>
            <v-card-title class="headline">{{
              $t("earlyBookingRemove")
            }}</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeDelete">{{
                $t("btnNo")
              }}</v-btn>
              <v-btn color="green darken-1" text @click="deleteItemConfirm">{{
                $t("btnYes")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  name: "EarlyBookingTable",

  mixins: [validationMixin],

  data() {
    return {
      dialog: false,
      dialogDelete: false,
      earlyBooking: [],
      headers: [
        {
          text: this.$i18n.t("earlyBookingDays"),
          align: "start",
          sortable: false,
          value: "days",
        },
        {
          text: this.$i18n.t("earlyBookingDiscount"),
          align: "start",
          sortable: false,
          value: "discount",
        },
        {
          text: this.$i18n.t("earlyBookingManage"),
          align: "end",
          sortable: false,
          value: "actions",
        },
      ],
      editedIndex: -1,
      editedItem: {
        days: null,
        discount: null,
      },
      defaultItem: {
        days: null,
        discount: null,
      },
    };
  },

  validations: {
    editedItem: {
      days: {
        required,
        minValue: minValue(1),
      },
      discount: {
        required,
        minValue: minValue(1),
      },
    },
  },

  computed: {
    earlyBookingDialogTitle() {
      return this.editedIndex === -1
        ? this.$i18n.t("earlyBookingAdd")
        : this.$i18n.t("earlyBookingChange");
    },
    earlyBookingDaysErrors() {
      const errors = [];
      if (!this.$v.editedItem.days.$dirty) return errors;
      !this.$v.editedItem.days.required &&
        errors.push(this.$i18n.t("validationRequired"));
      !this.$v.editedItem.days.minValue &&
        errors.push(this.$i18n.t("validationMinValue"));
      return errors;
    },
    earlyBookingDiscountErrors() {
      const errors = [];
      if (!this.$v.editedItem.discount.$dirty) return errors;
      !this.$v.editedItem.discount.required &&
        errors.push("validationRequired");
      !this.$v.editedItem.discount.minValue &&
        errors.push(this.$i18n.t("validationMinValue"));
      return errors;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$v.$reset();
    },
    save() {
      if (this.editedIndex > -1) {
        // Object.assign(this.earlyBooking[this.editedIndex], this.editedItem)
        this.editEarlyBookingCondition(this.editedItem).then(() => {
          this.loadEarlyBookingConditionsList();
        });
      } else {
        // this.earlyBooking.push(this.editedItem)
        this.createEarlyBookingCondition(this.editedItem).then(() => {
          this.loadEarlyBookingConditionsList();
        });
      }
      this.close();
      this.$v.$reset();
    },
    editItem(item) {
      this.editedIndex = this.earlyBooking.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.earlyBooking.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      // this.earlyBooking.splice(this.editedIndex, 1)
      this.removeEarlyBookingCondition(this.editedItem).then(() => {
        this.loadEarlyBookingConditionsList();
      });
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    loadEarlyBookingConditionsList() {
      this.getEarlyBookingConditions().then((response) => {
        this.earlyBooking = response.data;
      });
    },
    ...mapActions([
      "getEarlyBookingConditions",
      "createEarlyBookingCondition",
      "editEarlyBookingCondition",
      "removeEarlyBookingCondition",
    ]),
  },

  mounted() {
    this.loadEarlyBookingConditionsList();
  },
};
</script>
